import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaChevronRight, FaInstagram, FaMapMarkerAlt, FaWhatsapp } from 'react-icons/fa';
import { HeartPulse, Sparkles, UserRound } from 'lucide-react';
import styles from './tatienelibrelon.module.scss';
import Foto from './src/foto-principal.jpeg';
import Logo from './src/logo-tati-transp.png';
import { getWhatsappUrl, INSTAGRAM_URL, MAPS_URL } from './dados_tatienelibrelon.ts';

const LINKS = [
    {
        titulo: 'Serviços',
        descricao: 'Acupuntura, fertilidade e estética',
        to: '/tatienelibrelon/servicos',
        icon: <Sparkles size={20} />,
    },
    {
        titulo: 'Sobre mim',
        descricao: 'A mulher por trás da profissional',
        to: '/tatienelibrelon/sobremim',
        icon: <UserRound size={20} />,
    },
    {
        titulo: 'Agendar consulta',
        descricao: 'Tire suas dúvidas pelo WhatsApp',
        href: getWhatsappUrl(
            'Olá, Tatiene! Vim pelo Instagram e gostaria de agendar uma consulta.'
        ),
        icon: <HeartPulse size={20} />,
    },
];

const Tatienelibrelon: React.FC = () => {
    useEffect(() => {
        const html = document.documentElement;
        const previousLang = html.lang;
        html.lang = 'pt-BR';
        return () => {
            html.lang = previousLang;
        };
    }, []);

    return (
        <div className={styles.tatienelibrelon} lang="pt-BR">
            <div className={styles.shell}>
                <div className={styles.photoWrap}>
                    <img className={styles.photo} src={Foto} alt="Tatiene Librelon, biomédica" />
                </div>

                <div className={styles.page}>
                <div className={styles.hero}>
                    <p className={styles.eyebrow}>Biomédica</p>
                    <h1 className={`${styles.name} notranslate`} translate="no">
                        Tatiene Librelon
                    </h1>
                    <p className={styles.role}>Acupuntura e estética · Saúde da mulher</p>
                    <span className={styles.divider} />
                    <p className={styles.tagline}>
                        Cuidado individualizado e acolhedor, com ciência e medicina chinesa no mesmo olhar.
                    </p>
                </div>

                <div className={styles.socials}>
                    <a
                        href={getWhatsappUrl('Olá, Tatiene! Vim pelo Instagram e gostaria de mais informações.')}
                        className={styles.social}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="WhatsApp"
                    >
                        <FaWhatsapp />
                    </a>
                    <a
                        href={INSTAGRAM_URL}
                        className={styles.social}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                    >
                        <FaInstagram />
                    </a>
                    <a
                        href={MAPS_URL}
                        className={styles.social}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Localização"
                    >
                        <FaMapMarkerAlt />
                    </a>
                </div>

                <nav className={styles.links}>
                    {LINKS.map((item) => {
                        const conteudo = (
                            <>
                                <span className={styles.linkIcon}>{item.icon}</span>
                                <span className={styles.linkText}>
                                    <span className={styles.linkTitle}>{item.titulo}</span>
                                    <span className={styles.linkDesc}>{item.descricao}</span>
                                </span>
                                <FaChevronRight className={styles.linkArrow} />
                            </>
                        );

                        return item.to ? (
                            <Link key={item.titulo} to={item.to} className={styles.link}>
                                {conteudo}
                            </Link>
                        ) : (
                            <a
                                key={item.titulo}
                                href={item.href}
                                className={styles.link}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {conteudo}
                            </a>
                        );
                    })}
                </nav>

                <div className={styles.footer}>
                    <img
                        className={`${styles.logo} notranslate`}
                        src={Logo}
                        alt="Tatiene Librelon - Acupuntura e Estética"
                        translate="no"
                    />
                </div>
                </div>
            </div>
        </div>
    );
};

export default Tatienelibrelon;
